import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/fonts.css'
import './assets/styles/index.css';
import App from './App';

ReactDOM.render(<App/>, document.getElementById('root'));